import type { VariantProps } from '../../lib/stitches'
import { StyledMessage } from './message.styles'

export const Message = ({
  message,
  variant
}: {
  message: React.ReactElement
  variant: VariantProps<typeof StyledMessage>['variant']
}) => {
  return <StyledMessage variant={variant}>{message}</StyledMessage>
}
